module.exports = __webpack_public_path__ + "img/setting-line.dd691445.svg";